import {Component, Input} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {CompanyImagePipe} from "../../../pipes/company-image.pipe";

@Component({
  selector: 'app-answers-customers',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    CompanyImagePipe
  ],
  templateUrl: './answers-customers.component.html',
  styleUrl: './answers-customers.component.scss'
})
export class AnswersCustomersComponent {

  @Input() customers?: Array<any>;

  replacePlaceVariable(content: string, variable: string | null): string {
    if (!content || !variable) {
      return content;
    }
    return content.replace(/\[\]/g, variable);
  }
}
